import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpFromBracket } from '@fortawesome/pro-light-svg-icons/faArrowUpFromBracket';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex/row';
import { Text, TextType } from 'ui-components/components/text';
import { InventoryImport } from '../../../products-page/inventory/action-buttons/inventory-import';
import { messages } from './messages';
import styles from './styles.module.less';

export const InventoryImportSection = () => {
  return (
    <>
      <FlexRow className={styles['section-header']}>
        <Text className={styles['section-title']} textType={TextType.H3} value={messages.sectionHeader} />
        <InventoryImport
          renderOpener={(open) => (
            <Button className={styles['import-btn']} onClick={open} theme='unstyled'>
              <FontAwesomeIcon className={styles['import-icon']} icon={faArrowUpFromBracket} />
              <FormattedMessage {...messages.importButton} />
            </Button>
          )}
        />
      </FlexRow>
      <Text className={styles['section-description']} textType={TextType.Caption} value={messages.sectionDescription} />
    </>
  );
};
